import { render, staticRenderFns } from "./BlacklistUnternehmen.vue?vue&type=template&id=2481cce6"
import script from "./BlacklistUnternehmen.vue?vue&type=script&lang=js"
export * from "./BlacklistUnternehmen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports